import { useQuery } from '@tanstack/react-query'

import { matchandthriveApi, userApiClient } from 'api'
import { useHostPlatform } from 'providers/HostPlatformProvider'
import { HubUserResponse, UserProfile } from 'types/user'

const mapWppUser = (user: HubUserResponse): UserProfile => ({
  id: user.id,
  firstName: user.firstname || '',
  lastName: user.lastname || '',
  email: user.email,
  department: user.company,
  jobFamilyName: user.jobFamilyName || undefined,
  avatarUrl: user.imageObj?.url || user.image || null,
})

export const useUserQuery = (enabled = true) => {
  const { isWpp, platform } = useHostPlatform()

  return useQuery<UserProfile>({
    queryKey: ['userProfile', platform],
    queryFn: async () => {
      if (isWpp) {
        const response = await matchandthriveApi.client.get<HubUserResponse>('/users/me')
        return mapWppUser(response.data)
      }

      const response = await userApiClient.client.get<UserProfile>('/v3/users/me?workdaySync=true')
      return response.data
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  })
}
